
import { Box, Container, Typography, Paper } from "@mui/material";
import { EventsTable } from "../common/events-table/events-table";
import IconBreadcrumbs from "../custom-breadcrumb";

const EventsPage = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 5, sm: 7, md: 10 },
                position: "relative",
                overflow: "hidden",
                background:
                    "radial-gradient(circle at 50% -10%, rgba(255,84,32,0.16), transparent 35%), radial-gradient(circle at 100% 45%, rgba(213,47,12,0.055), transparent 30%), linear-gradient(180deg, #030303 0%, #080808 55%, #020202 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.85), transparent)",
                },

                "&:after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "linear-gradient(rgba(255,84,32,0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,84,32,0.018) 1px, transparent 1px)",
                    backgroundSize: "45px 45px",
                    pointerEvents: "none",
                },
            }}
        >
            {/* =========================================================
                BACKGROUND FIRE GLOW - TOP RIGHT
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-250px",
                    right: "-250px",
                    width: "650px",
                    height: "650px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.12) 0%, rgba(181,42,13,0.045) 35%, transparent 68%)",
                    filter: "blur(100px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================================
                BACKGROUND FIRE GLOW - BOTTOM LEFT
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "-300px",
                    left: "-300px",
                    width: "700px",
                    height: "700px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.065) 0%, rgba(142,29,11,0.025) 35%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* =========================================================
                CENTER EMBER GLOW
            ========================================================== */}
            <Box
                sx={{
                    position: "absolute",
                    top: "35%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "500px",
                    height: "500px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(255,84,32,0.025), transparent 70%)",
                    filter: "blur(100px)",
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* =====================================================
                    BREADCRUMB
                ====================================================== */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 5 },
                        "& *": {
                            color: "#777",
                        },
                    }}
                >
                    <IconBreadcrumbs />
                </Box>

                {/* =====================================================
                    HEADER
                ====================================================== */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: { xs: 5, md: 7 },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#ff7135",
                            fontWeight: 800,
                            letterSpacing: "4px",
                            fontSize: "11px",
                            mb: 1.5,
                            textTransform: "uppercase",
                            textShadow:
                                "0 0 20px rgba(255,84,32,0.25)",
                        }}
                    >
                        VEX • EVENT SCHEDULE
                    </Typography>

                    <Typography
                        sx={{
                            color: "#fff",
                            fontWeight: 900,
                            fontSize: {
                                xs: "38px",
                                sm: "48px",
                                md: "62px",
                            },
                            lineHeight: 1,
                            mb: 2.5,
                            letterSpacing: "-1px",
                            textShadow:
                                "0 5px 30px rgba(0,0,0,0.6)",
                        }}
                    >
                        SERVER{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#ff7135",
                                textShadow:
                                    "0 0 30px rgba(255,84,32,0.28)",
                            }}
                        >
                            EVENTS
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.55)",
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                            },
                            maxWidth: "720px",
                            margin: "0 auto",
                            lineHeight: 1.8,
                        }}
                    >
                        Stay updated with all upcoming events,
                        tournaments, guild wars, and server activities
                        happening inside Vex Conquer.
                    </Typography>

                    {/* FIRE ACCENT LINE */}
                    <Box
                        sx={{
                            width: 90,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 15px rgba(255,84,32,0.25)",
                        }}
                    />

                    {/* SERVER TAGS */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: 1,
                            mt: 3,
                        }}
                    >
                        {[
                            "5165 CLASSIC",
                            "LEVEL 130",
                            "1ST REBORN",
                            "CLASSIC PVP",
                        ].map((tag) => (
                            <Box
                                key={tag}
                                sx={{
                                    px: 1.5,
                                    py: 0.7,
                                    borderRadius: "6px",
                                    border:
                                        "1px solid rgba(255,84,32,0.16)",
                                    background:
                                        "rgba(255,84,32,0.045)",
                                    color: "#9a9a9a",
                                    fontSize: "9px",
                                    fontWeight: 800,
                                    letterSpacing: "1.2px",
                                }}
                            >
                                {tag}
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* =====================================================
                    EVENTS CARD
                ====================================================== */}
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: {
                            xs: "20px",
                            md: "28px",
                        },
                        background:
                            "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(7,7,7,0.99))",
                        border:
                            "1px solid rgba(255,84,32,0.16)",
                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.65), inset 0 1px 0 rgba(255,255,255,0.025)",
                        overflow: "hidden",
                        position: "relative",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #b52a0d, #ff5420, #ff9a4d, #ff5420, #b52a0d, transparent)",
                        },
                    }}
                >
                    {/* =================================================
                        TOP HEADER
                    ================================================== */}
                    <Box
                        sx={{
                            px: {
                                xs: 3,
                                sm: 4,
                                md: 5,
                            },
                            py: {
                                xs: 3.5,
                                md: 4.5,
                            },
                            borderBottom:
                                "1px solid rgba(255,255,255,0.055)",
                            background:
                                "linear-gradient(135deg, rgba(255,84,32,0.055), rgba(10,10,10,0.98))",
                            position: "relative",

                            "&:after": {
                                content: '""',
                                position: "absolute",
                                right: 0,
                                top: 0,
                                width: "35%",
                                height: "100%",
                                background:
                                    "linear-gradient(90deg, transparent, rgba(255,84,32,0.025))",
                                pointerEvents: "none",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: {
                                    xs: "flex-start",
                                    sm: "center",
                                },
                                justifyContent: "space-between",
                                gap: 2,
                                flexWrap: "wrap",
                            }}
                        >
                            <Box>
                                <Typography
                                    sx={{
                                        color: "#ff7135",
                                        fontWeight: 900,
                                        fontSize: {
                                            xs: "25px",
                                            md: "34px",
                                        },
                                        lineHeight: 1.1,
                                        mb: 1,
                                        letterSpacing: "-0.3px",
                                    }}
                                >
                                    Event Schedules
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#777",
                                        fontSize: {
                                            xs: "13px",
                                            md: "14px",
                                        },
                                        lineHeight: 1.8,
                                        maxWidth: "650px",
                                    }}
                                >
                                    Always updated event timings and
                                    server activities for all players.
                                </Typography>

                                {/* SMALL FIRE ACCENT */}
                                <Box
                                    sx={{
                                        width: 45,
                                        height: 3,
                                        borderRadius: "10px",
                                        background:
                                            "linear-gradient(90deg, #ff5420, transparent)",
                                        mt: 2,
                                        boxShadow:
                                            "0 0 10px rgba(255,84,32,0.2)",
                                    }}
                                />
                            </Box>

                            {/* LIVE EVENTS BADGE */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.7,
                                    py: 1,
                                    borderRadius: "8px",
                                    border:
                                        "1px solid rgba(255,84,32,0.18)",
                                    background:
                                        "rgba(255,84,32,0.05)",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 7,
                                        height: 7,
                                        borderRadius: "50%",
                                        background: "#ff5420",
                                        boxShadow:
                                            "0 0 12px rgba(255,84,32,0.7)",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#aaa",
                                        fontSize: "9px",
                                        fontWeight: 800,
                                        letterSpacing: "1.4px",
                                    }}
                                >
                                    EVENT SCHEDULE
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* =================================================
                        TABLE
                    ================================================== */}
                    <Box
                        sx={{
                            p: {
                                xs: 1.5,
                                sm: 2.5,
                                md: 4,
                            },
                            overflowX: "auto",
                            color: "#fff",

                            "& table": {
                                borderCollapse: "separate",
                                borderSpacing: "0 6px",
                            },

                            "& th": {
                                color: "#ff7135",
                                fontWeight: 800,
                                fontSize: "11px",
                                letterSpacing: "1.5px",
                                textTransform: "uppercase",
                            },

                            "& td": {
                                color: "#aaa",
                                borderColor:
                                    "rgba(255,255,255,0.04)",
                            },

                            "& tr": {
                                transition:
                                    "all 0.2s ease",
                            },

                            "& tbody tr:hover": {
                                background:
                                    "rgba(255,84,32,0.045)",
                            },
                        }}
                    >
                        <EventsTable />
                    </Box>
                </Paper>

                {/* =====================================================
                    EVENT INFO STRIP
                ====================================================== */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(3, 1fr)",
                        },
                        mt: 3,
                        gap: 1.5,
                    }}
                >
                    {[
                        {
                            value: "5165",
                            label: "CLASSIC CORE",
                        },
                        {
                            value: "24/7",
                            label: "SERVER ACTIVITY",
                        },
                        {
                            value: "PVP",
                            label: "CLASSIC BATTLES",
                        },
                    ].map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                textAlign: "center",
                                py: 2.2,
                                px: 2,
                                borderRadius: "12px",
                                border:
                                    "1px solid rgba(255,84,32,0.09)",
                                background:
                                    "linear-gradient(145deg, rgba(255,84,32,0.035), rgba(255,255,255,0.012))",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontSize: "16px",
                                    fontWeight: 900,
                                    letterSpacing: "1px",
                                }}
                            >
                                {item.value}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#555",
                                    fontSize: "8px",
                                    fontWeight: 800,
                                    letterSpacing: "1.5px",
                                    mt: 0.4,
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* =====================================================
                    CTA
                ====================================================== */}
                <Box
                    sx={{
                        mt: {
                            xs: 6,
                            md: 9,
                        },
                        textAlign: "center",
                        position: "relative",
                        background:
                            "linear-gradient(145deg, rgba(18,10,8,0.99), rgba(8,8,8,0.99))",
                        borderRadius: {
                            xs: "22px",
                            md: "28px",
                        },
                        py: {
                            xs: 5,
                            md: 7,
                        },
                        px: 3,
                        border:
                            "1px solid rgba(255,84,32,0.15)",
                        boxShadow:
                            "0 25px 60px rgba(0,0,0,0.6)",
                        overflow: "hidden",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: "50%",
                            transform:
                                "translateX(-50%)",
                            width: "40%",
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #ff5420, #ff9a4d, #ff5420, transparent)",
                            boxShadow:
                                "0 0 15px rgba(255,84,32,0.25)",
                        },

                        "&:after": {
                            content: '""',
                            position: "absolute",
                            width: 350,
                            height: 350,
                            borderRadius: "50%",
                            left: "50%",
                            bottom: -280,
                            transform:
                                "translateX(-50%)",
                            background:
                                "rgba(255,84,32,0.045)",
                            filter: "blur(80px)",
                            pointerEvents: "none",
                        },
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            zIndex: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#ff7135",
                                fontWeight: 800,
                                letterSpacing: "4px",
                                fontSize: "11px",
                                mb: 1.5,
                                textTransform: "uppercase",
                                textShadow:
                                    "0 0 15px rgba(255,84,32,0.2)",
                            }}
                        >
                            READY FOR BATTLE?
                        </Typography>

                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "32px",
                                    sm: "42px",
                                    md: "54px",
                                },
                                lineHeight: 1.1,
                                mb: 2.5,
                                letterSpacing: "-0.7px",
                            }}
                        >
                            Join{" "}
                            <Box
                                component="span"
                                sx={{
                                    color: "#ff7135",
                                    textShadow:
                                        "0 0 25px rgba(255,84,32,0.22)",
                                }}
                            >
                                Upcoming Events
                            </Box>
                        </Typography>

                        <Typography
                            sx={{
                                color: "#777",
                                fontSize: {
                                    xs: "14px",
                                    md: "16px",
                                },
                                maxWidth: "680px",
                                margin: "0 auto",
                                lineHeight: 1.9,
                            }}
                        >
                            Compete with warriors across Vex Conquer,
                            fight for your guild, dominate the battlefield,
                            and build your legacy in Classic 5165.
                        </Typography>

                        {/* DECORATIVE FIRE DIVIDER */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 2,
                                mt: 3.5,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: "1px",
                                    background:
                                        "linear-gradient(90deg, transparent, rgba(255,84,32,0.35))",
                                }}
                            />

                            <Box
                                sx={{
                                    width: 5,
                                    height: 5,
                                    borderRadius: "50%",
                                    background:
                                        "#ff5420",
                                    boxShadow:
                                        "0 0 12px rgba(255,84,32,0.65)",
                                }}
                            />

                            <Box
                                sx={{
                                    width: 60,
                                    height: "1px",
                                    background:
                                        "linear-gradient(90deg, rgba(255,84,32,0.35), transparent)",
                                }}
                            />
                        </Box>
                    </Box>
                </Box>

                {/* =====================================================
                    BOTTOM BRAND
                ====================================================== */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(255,84,32,0.25))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#444",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Vex Conquer • 5165 Classic
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(255,84,32,0.25), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default EventsPage;

